import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  main_beneficial_owners_rate: {
    name: "Percentage of the AIF's equity owned by the five beneficial owners that have the largest equity interest in the AIF",
    order: 74,
    letter: 'A'
  }
};

export function InvestorConcetration({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.INVESTOR_CONCENTRATION,
    onChangeFund,
    schema: schema.INVESTOR_CONCENTRATION,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.INVESTOR_CONCENTRATION?.field_names || [],
    columnLables,
    tableName: 'INVESTOR_CONCENTRATION',
    isMultiFunds,
    funds
  });

  return (
    <Table
      id="fca-reporttables-investor-concentration-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
